module.exports = __webpack_public_path__ + "assets/img/main2.5c5da0dc.jpg";